import { SENDGRID_ACCOUNTS } from '@mm/api-routes';
import {
  SendGridAccount,
  SendGridAccountsResponse,
} from '../model/SendGridModel';
import AuthenticatedController from './AuthenticatedController';
import Controller, { DEFAULT_HEADERS } from './Controller';

export default class SendGridController extends AuthenticatedController {
  static async getAccounts(
    apiKey: string | number,
  ): Promise<SendGridAccountsResponse> {
    const response = await fetch(SENDGRID_ACCOUNTS(apiKey), {
      method: 'GET',
      headers: AuthenticatedController.addAuthTokenToHeaders(DEFAULT_HEADERS),
    });
    await Controller.handleFailedResponse(response);
    const responseJson = await response.json();
    return responseJson;
  }

  static async createAccounts({
    apiKey,
    facebookPageId,
    accounts,
  }: {
    apiKey: string | number;
    facebookPageId: number;
    accounts: {
      [key: string]: SendGridAccount;
    };
  }) {
    return super.post(
      SENDGRID_ACCOUNTS(),
      {
        [typeof apiKey === 'number' ? 'api_key_id' : 'api_key']: apiKey,
        facebook_page_id: facebookPageId,
        accounts,
      },
      null,
      DEFAULT_HEADERS,
      null,
      false,
      true,
    );
  }
}
